const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-BluntRed">
      {/* Header */}
      <header className="bg-BluntRed text-white py-6 shadow-lg">
        <div className="max-w-5xl mx-auto px-4">
          <h1 className="text-3xl font-bold">Terms of Use & Privacy Policy</h1>
          <p className="text-BluntRed mt-2">BookMyPooja.Online</p>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-5xl mx-auto px-4 py-12">
        <div className="bg-white rounded-lg shadow-md p-8">
          
          {/* Terms of Use */}
          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-BluntRed mb-4">Terms of Use</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              The Website Owner, including subsidiaries and affiliates (&#34;BookMyPoojaOnline.com&#34; or &#34;we&#34; or &#34;us&#34; or &#34;our&#34; or &#34;MetaPlus&#34; Technologies Private Limited&#34;) provides the information contained on the website or any of the pages comprising the website (&#34;website&#34;) to visitors (&#34;visitors&#34;) (cumulatively referred to as &#34;you&#34; or &#34;your&#34; hereinafter) subject to the terms and conditions set out in these website terms and conditions, the privacy policy and any other relevant terms and conditions, policies and notices which may be applicable to a specific section or module of the website.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              If you continue to browse and use this website you are agreeing to comply with and be bound by the following terms and conditions of use, which together with our privacy policy govern BookMyPooja.Online relationship with you in relation to this website.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              The term &#39;BookMyPooja.Online&#39; or &#39;us&#39; or &#39;we&#39; refers to the MetaPlus Technologies Private Limited, a Private Limited Company registered under Companies Act, 2013. The company head office is in Bangalore. The term &#39;you&#39; refers to the user or viewer of this website.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              We are in the business of providing an online, convenient, transparent and hassle-free experience in context with performing various religious rituals, as updated and modified on the website from time to time. Apart from the service provision, there may be other religious goods and products that will be displayed for purchase by the customer.
            </p>
            <p className="text-gray-700 leading-relaxed">
              For any issues or queries, you can reach out to us at +91 98699 29292 or email us at support@bookmypooja.online.
            </p>
          </section>

          {/* Refunds and Cancellations Policy */}
          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-BluntRed mb-4">Refunds and Cancellations Policy</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              We understand that you may have to cancel the Pooja ceremony for some reasons.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              In case of customer-initiated cancellations, you need to cancel the puja from &#34;My Orders&#34; section in your account and get in touch with our customer care number 8150878717 via Call / WhatsApp or email us on our official support email ID.
            </p>
            <div className="bg-BluntRed p-4 rounded-lg mb-4">
              <p className="text-white mb-2">• If the pooja is cancelled for more than 96 hours, 90% amount will be refunded.</p>
              <p className="text-white mb-2">• If the pooja is cancelled for 48 to 96 hours, 50% amount will be refunded.</p>
              <p className="text-white">• If the pooja is cancelled for 0 to 48 hours, no amount will be refunded.</p>
            </div>
            <p className="text-gray-700 leading-relaxed">
              We strive to provide the best experience possible, however in some cases if Pandit ji cannot attend the scheduled Pooja, BookMyPooja shall process full refund within 5 working days.
            </p>
          </section>

          {/* Data Policy & Terms of Service */}
          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-BluntRed mb-6">Data Policy & Terms of Service</h2>

            {/* 1. Definitions */}
            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">1. Definitions</h3>
              <div className="bg-gray-50 p-4 rounded-lg space-y-2">
                <p className="text-gray-700">• &#34;Customer/User&#34; – Anyone using the Website/App to book pujas, homas, havans, consultations, or related services.</p>
                <p className="text-gray-700">• &#34;Pandit/Priest/Service Provider&#34; – Vedic priest registered on the Pandit Companion App to perform pujas/homas for customers.</p>
                <p className="text-gray-700">• &#34;Services&#34; – Includes offline puja services, online ePuja services, live video pujas, bookings, customer support, samagri provision, and all related offerings.</p>
                <p className="text-gray-700">• &#34;Platform&#34; – Website, customer app, pandit app, WhatsApp communication, and any digital channel operated by BookMyPooja.</p>
              </div>
            </div>

            {/* 2. Eligibility */}
            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">2. Eligibility</h3>
              <p className="text-gray-700 leading-relaxed mb-3">By using BookMyPooja, you confirm that:</p>
              <div className="bg-BluntRed p-4 rounded-lg space-y-2">
                <p className="text-white">• You are at least 18 years old, or</p>
                <p className="text-white">• A parent/guardian is supervising the use (for minors using the Platform to book pujas).</p>
                <p className="text-white">• You are competent to enter into a contract under Indian law.</p>
              </div>
            </div>

            {/* 3. Service Description */}
            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">3. Service Description</h3>
              <p className="text-gray-700 leading-relaxed mb-3">BookMyPooja is a religious & cultural service platform that helps users:</p>
              <div className="bg-gray-50 p-4 rounded-lg space-y-2 mb-3">
                <p className="text-gray-700">• Book offline pujas performed at home, office, temple, or venue.</p>
                <p className="text-gray-700">• Book live online ePujas conducted over video.</p>
                <p className="text-gray-700">• Access verified pandits in multiple languages.</p>
                <p className="text-gray-700">• Receive samagri, puja items, and ritual support.</p>
                <p className="text-gray-700">• Use the Pandit Companion App for pandits to manage schedules, samagri lists, and ePuja sessions.</p>
              </div>
              <p className="text-gray-700 leading-relaxed">
                BookMyPooja acts as a technology facilitator enabling coordination between customers and pandits. BookMyPooja is not liable for religious outcomes, as rituals are spiritual in nature.
              </p>
            </div>

            {/* 4. Booking Confirmation */}
            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">4. Booking Confirmation</h3>
              <p className="text-gray-700 leading-relaxed mb-3">A booking is considered confirmed only when:</p>
              <div className="bg-BluntRed p-4 rounded-lg space-y-2 mb-3">
                <p className="text-white">• Required information is submitted.</p>
                <p className="text-white">• Payment (full/partial) is successfully completed.</p>
                <p className="text-white">• Confirmation is sent via WhatsApp / SMS / email.</p>
              </div>
              <p className="text-gray-700 leading-relaxed mb-2">BookMyPooja reserves the right to decline or cancel any booking due to:</p>
              <div className="bg-gray-50 p-4 rounded-lg space-y-2">
                <p className="text-gray-700">• Unavailability of pandits.</p>
                <p className="text-gray-700">• Incorrect details shared.</p>
                <p className="text-gray-700">• Payment failure.</p>
                <p className="text-gray-700">• Operational issues.</p>
              </div>
            </div>

            {/* 5. User Responsibilities */}
            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">5. User Responsibilities (Customers)</h3>
              <p className="text-gray-700 leading-relaxed mb-3">Customers agree to:</p>
              <div className="bg-BluntRed p-4 rounded-lg space-y-2 mb-3">
                <p className="text-white">• Provide accurate details during booking.</p>
                <p className="text-white">• Maintain respect and appropriate behaviour during interactions with pandits.</p>
                <p className="text-white">• Ensure safety of pandits at the location.</p>
                <p className="text-white">• Not misuse the platform or engage in fraudulent activity.</p>
                <p className="text-white">• Not attempt to directly hire pandits outside the platform (contact-poaching is prohibited).</p>
              </div>
              <p className="text-gray-700 leading-relaxed">
                Booking services imply acceptance of these responsibilities.
              </p>
            </div>

            {/* 6. Responsibilities of Pandits */}
            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">6. Responsibilities of Pandits</h3>
              <p className="text-gray-700 leading-relaxed mb-3">Pandits using our Pandit Companion App agree to:</p>
              <div className="bg-gray-50 p-4 rounded-lg space-y-2 mb-3">
                <p className="text-gray-700">• Perform rituals with discipline, punctuality, and authenticity.</p>
                <p className="text-gray-700">• Follow cultural and religious procedures as per customer preferences.</p>
                <p className="text-gray-700">• Maintain respectful behaviour.</p>
                <p className="text-gray-700">• Avoid solicitation of customers outside BookMyPooja.</p>
                <p className="text-gray-700">• Provide accurate schedule availability.</p>
                <p className="text-gray-700">• Use the app responsibly and truthfully.</p>
                <p className="text-gray-700">• Comply with training, quality checks & feedback guidelines.</p>
              </div>
              <p className="text-gray-700 leading-relaxed">
                Violation may lead to suspension or termination.
              </p>
            </div>

            {/* 7. Payments, Pricing & Taxes */}
            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">7. Payments, Pricing & Taxes</h3>
              <div className="bg-BluntRed p-4 rounded-lg space-y-2 mb-3">
                <p className="text-white">• All prices listed on the Platform are inclusive/exclusive of taxes as stated.</p>
                <p className="text-white">• Payment can be made via UPI, credit/debit cards, wallets, or net banking.</p>
                <p className="text-white">• BookMyPooja may modify prices at any time.</p>
              </div>
              <h4 className="text-lg font-semibold text-gray-800 mb-2 mt-4">Invoices & Settlements</h4>
              <div className="bg-gray-50 p-4 rounded-lg space-y-2">
                <p className="text-gray-700">• Customers receive an invoice digitally.</p>
                <p className="text-gray-700">• Pandits receive settlements through bank/UPI after completion of services.</p>
              </div>
            </div>

            {/* 8. Cancellations & Refunds */}
            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">8. Cancellations & Refunds</h3>
              <p className="text-gray-700 leading-relaxed">
                Refunds are governed by BookMyPooja&#39;s Refunds and Cancellations Policy stated above in this document.
              </p>
            </div>

            {/* 9. ePuja & Live Streaming Terms */}
            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">9. ePuja & Live Streaming Terms</h3>
              <div className="bg-BluntRed p-4 rounded-lg space-y-2">
                <p className="text-white">• Users must ensure internet connectivity during online pujas.</p>
                <p className="text-white">• Video recordings (if provided) will be shared only via secure cloud links.</p>
                <p className="text-white">• Unauthorized downloading or redistribution of recordings is prohibited.</p>
                <p className="text-white">• BookMyPooja is not responsible for disruptions caused by network issues beyond its control.</p>
              </div>
            </div>

            {/* 10. Prohibited Activities */}
            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">10. Prohibited Activities</h3>
              <p className="text-gray-700 leading-relaxed mb-3">Users (customers & pandits) must NOT:</p>
              <div className="bg-gray-50 p-4 rounded-lg space-y-2 mb-3">
                <p className="text-gray-700">• Misuse or attempt to hack the Platform.</p>
                <p className="text-gray-700">• Use abusive or disrespectful behaviour.</p>
                <p className="text-gray-700">• Host or share inappropriate content through the Platform.</p>
                <p className="text-gray-700">• Impersonate others or provide false information.</p>
                <p className="text-gray-700">• Attempt to hire pandits outside the platform.</p>
                <p className="text-gray-700">• Copy, redistribute, or reverse engineer the Platform.</p>
              </div>
              <p className="text-gray-700 leading-relaxed">
                Violation may lead to termination or legal action.
              </p>
            </div>

            {/* 11. Intellectual Property */}
            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">11. Intellectual Property</h3>
              <div className="bg-BluntRed p-4 rounded-lg space-y-2">
                <p className="text-white">• All content, graphics, code, data, workflows, branding and media on the Platform are the exclusive property of Metaplus Technologies Pvt. Ltd.</p>
                <p className="text-white">• You may not reproduce or use our intellectual property without written permission.</p>
                <p className="text-white">• Ritual-related content (videos, images, samagri lists) is also protected.</p>
              </div>
            </div>

            {/* 12. Third-Party Services */}
            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">12. Third-Party Services</h3>
              <p className="text-gray-700 leading-relaxed mb-3">Our Platform may integrate:</p>
              <div className="bg-gray-50 p-4 rounded-lg space-y-2 mb-3">
                <p className="text-gray-700">• Payment gateways.</p>
                <p className="text-gray-700">• SMS / WhatsApp service providers.</p>
                <p className="text-gray-700">• Analytics platforms.</p>
                <p className="text-gray-700">• Cloud hosting providers.</p>
              </div>
              <p className="text-gray-700 leading-relaxed">
                Use of these services is governed by their respective terms and policies.
              </p>
            </div>

            {/* 13. Limitation of Liability */}
            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">13. Limitation of Liability</h3>
              <p className="text-gray-700 leading-relaxed mb-3">BookMyPooja is not responsible for:</p>
              <div className="bg-BluntRed p-4 rounded-lg space-y-2 mb-3">
                <p className="text-white">• Religious outcomes or expectations.</p>
                <p className="text-white">• Pandit&#39;s individual interpretation or method of ritual.</p>
                <p className="text-white">• Loss caused by inaccurate user information.</p>
                <p className="text-white">• Internet outages or technical disruptions.</p>
                <p className="text-white">• Delays caused by traffic, location access issues, or emergencies.</p>
                <p className="text-white">• Personal injuries or property damage at the customer&#39;s site.</p>
              </div>
              <p className="text-gray-700 leading-relaxed">
                Our liability is limited to the amount paid for the booking.
              </p>
            </div>

            {/* 14. Indemnification */}
            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">14. Indemnification</h3>
              <p className="text-gray-700 leading-relaxed mb-3">You agree to indemnify and hold BookMyPooja harmless from:</p>
              <div className="bg-gray-50 p-4 rounded-lg space-y-2">
                <p className="text-gray-700">• Claims caused by misuse of the Platform.</p>
                <p className="text-gray-700">• Violations of these Terms.</p>
                <p className="text-gray-700">• Actions arising from personal interactions with pandits or users.</p>
                <p className="text-gray-700">• Any fraud or unlawful activity conducted through your account.</p>
              </div>
            </div>

            {/* 15. Termination */}
            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">15. Termination</h3>
              <p className="text-gray-700 leading-relaxed mb-3">BookMyPooja may suspend or terminate access if:</p>
              <div className="bg-BluntRed p-4 rounded-lg space-y-2 mb-3">
                <p className="text-white">• User violates these Terms.</p>
                <p className="text-white">• Fraudulent activity is detected.</p>
                <p className="text-white">• Abuse or misconduct is reported.</p>
                <p className="text-white">• Legal or safety risks arise.</p>
              </div>
              <p className="text-gray-700 leading-relaxed">
                You may also request account closure at any time.
              </p>
            </div>

            {/* 16. Data Privacy */}
            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">16. Data Privacy</h3>
              <p className="text-gray-700 leading-relaxed mb-3">
                Use of our Platform is governed by the BookMyPooja Privacy Policy, incorporated by reference into these Terms.
              </p>
              <p className="text-gray-700 leading-relaxed mb-2">All users must read the Privacy Policy for details about:</p>
              <div className="bg-gray-50 p-4 rounded-lg space-y-2">
                <p className="text-gray-700">• Data collection.</p>
                <p className="text-gray-700">• Usage.</p>
                <p className="text-gray-700">• Storage.</p>
                <p className="text-gray-700">• Sharing.</p>
                <p className="text-gray-700">• Rights of users.</p>
              </div>
            </div>

            {/* 17. Governing Law & Jurisdiction */}
            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">17. Governing Law & Jurisdiction</h3>
              <p className="text-gray-700 leading-relaxed mb-3">
                These Terms shall be governed by and interpreted in accordance with the laws of India.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Any disputes shall be subject to the exclusive jurisdiction of the courts in: <strong>Bangalore, Karnataka.</strong>
              </p>
            </div>

            {/* 18. Changes to Terms */}
            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">18. Changes to Terms</h3>
              <p className="text-gray-700 leading-relaxed mb-3">
                We reserve the right to update or modify these Terms at any time. Updates will be posted on the Platform with the &#34;Last Updated&#34; date.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Continued use of the Platform constitutes acceptance of revised Terms.
              </p>
            </div>

            {/* 19. Contact Us */}
            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">19. Contact Us</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                For any questions or concerns regarding these Terms or policies, you may contact us:
              </p>
              <div className="bg-BluntRed border-l-4 border-BluntRed p-6 rounded">
                <p className="text-white mb-2">Email: support@bookmypooja.online</p>
                <p className="text-white">Phone: 9869 92 92 92 / 8150 87 87 17</p>
              </div>
            </div>
          </section>

        </div>
      </main>

      {/* Footer */}
      <footer className="bg-BluntRed text-white py-6 mt-12">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <p className="text-BluntRed">© 2025 MetaPlus Technologies Private Limited. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};
export default PrivacyPolicy;
